import React, { useState, useEffect } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutPage from "./CheckoutPage";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const StripeContainer = () => {
  const [stripeLoaded, setStripeLoaded] = useState(false);
  const [stripeError, setStripeError] = useState(null);

  useEffect(() => {
    stripePromise
      .then(() => {
        setStripeLoaded(true);
        setStripeError(null);
      })
      .catch((error) => {
        console.error("Failed to load Stripe:", error);
        setStripeError("Failed to load payment system. Please refresh the page.");
      });
  }, []);

  if (stripeError) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-lg text-red-600">{stripeError}</div>
      </div>
    );
  }

  if (!stripeLoaded) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-lg">Loading payment system...</div>
      </div>
    );
  }

  return (
    <Elements stripe={stripePromise}>
      <CheckoutPage />
    </Elements>
  );
};

export default StripeContainer;